import { render, staticRenderFns } from "./Ethnicity.vue?vue&type=template&id=13c42e07"
import script from "./Ethnicity.vue?vue&type=script&lang=js"
export * from "./Ethnicity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports